export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de lotes"])},
          "harvested_batches_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lotes"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear nuevo lote"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        }
      }
    }
  })
}